$(document).ready(function() {
    $('select[name="podcast_categories"]').on("change", function(){
      $.ajax({
        url : "/classement/ajx_podcast_subcategory/"+$(this ).val()+"/"+$('[name="periode"]').val(),
        dataType: "json",
        success: function ( data ) {
            $('select[name="podcast_subcategories"]').html("");
            $('select[name="podcast_subcategories"]').append('<option value=""> Choisissez une sous catégorie </option>');
            jQuery.each(data, function(index, item) {
              $('select[name="podcast_subcategories"]').append('<option value="'+item+'">'+item+'</option>');
            });
            $('.selectpicker').selectpicker('refresh');
        },
        error: function () {
            alert("Une erreur s'est produite");
        }
      });
    });
    $('select[name="thematic"]').on("change", function(){
        $.ajax({
            url : "/classement/ajx_thematic/"+$(this ).val(),
            dataType: "json",
            success: function ( data ) {
                $('select[name="sous-thematic"]').html("");
                for ( var i = 0; i < data.length; i++ ) {
                    $('select[name="sous-thematic"]').append('<option value="'+data[i].id+'">'+data[i].child+" "+data[i].parent+'</option>');
                }
                $('.selectpicker').selectpicker('refresh');
            },
            error: function () {
                alert("Une erreur s'est produite");
            }
        });
    });

    $("#submit-archive").on( "click", function(){
        var archive_form = $("#archive-form");
        var period = $('select[name="period"]').val();
        var action = archive_form.attr( "action" );
        var newaction = action + "=" + period;
        archive_form.attr("action", newaction );
        archive_form.submit();
        return false;
    });

    // link ligne table
    $("table.tablesorter").on("click", "tr[data-href]", function(){
        window.location.href = $(this).data("href");
    });

    /*extend tablesorter to support natural sort for numbers*/
    $.tablesorter.addParser({
        id: 'numeric_filter',
        format: function(s) {
            var new_text = parseFloat(s.replace(/\s/g, "").replace(',','.'));
            return isNaN(new_text) ? 0 : new_text;
        },
        type: 'numeric'
    });
    $.tablesorter.addParser({
        id: 'numeric_filter_evol',
        format: function(s) {
            var new_text = parseFloat(s.replace(/\s/g, "").replace(',','.'));
            return isNaN(new_text) ? 100 : new_text;
        },
        type: 'numeric'
    });
    $.tablesorter.addParser({
        id: 'specific_criterion',
        format: function(s, table, cell) {
            var diffFRPaye = cell.parentNode.cells[5].innerHTML;
            var diffFRPayeCleaned = parseFloat( diffFRPaye.replace( "&nbsp;", "" ).replace(/\s/g, "").replace(',','.') );
            var new_text = parseFloat(s.replace(/\s/g, "").replace(',','.'));
            return isNaN(diffFRPayeCleaned) ? 9999999999999999999 : new_text;
        },
        type: 'numeric'
    });
    $.tablesorter.addParser({
        id: 'custom_numeric_filter',
        format: function(s, table, cell) {
            var new_text = parseFloat(s.replace(/\s/g, "").replace(',','.'));
            return isNaN(new_text) ? $(table).find("tbody tr").length : new_text;
        },
        type: 'numeric'
    });
    $.tablesorter.addParser({
        id: 'custom_criterion',
        format: function(s, table, cell) {
            var sortcriterion = $(cell).attr('data-sortcriterion').toLowerCase();
            return (sortcriterion) ? sortcriterion : s.toLowerCase();
        },
        type: 'text'
    });
    $.tablesorter.addParser({
        id: 'custom_criterion_specific_classement',
        format: function(s, table, cell) {
            let sortcriterion = $(cell).attr('data-sortcriterion').toLowerCase();
            if ( $(cell).attr('data-sortsupportype') == 1 ) {
                sortcriterion = "zz"+sortcriterion;
            }
            return (sortcriterion) ? sortcriterion : s.toLowerCase();
        },
        type: 'text'
    });
    $.tablesorter.addParser({
        id: 'period_numeric_filter',
        format: function(s) {
            var new_text = parseInt(s.replace(/\s/g, "").replace(/h|m|s/g, ''));
            return isNaN(new_text) ? 0 : new_text;
        },
        type: 'numeric'
    });

    let table_classement = $("#classement");

    if (table_classement.is(".general.presse")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0,0],[4,0],[6,1],[2,0]],
            headers: {
                0: {
                    sorter:'custom_numeric_filter',
                    emptyToBottom: 'bottom'
                },
                2: {sorter:'custom_criterion'},
                4: {sorter:'specific_criterion'},
                6: {sorter:'numeric_filter'},
                7: {sorter:'numeric_filter_evol'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".personnalise.presse")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            headers: {
                1: {sorter: 'custom_criterion'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".general.numerique.site")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0, 0]],
            headers : {
                2: {sorter:'custom_criterion'},
                3: {sorter:'custom_criterion'},
                4: {sorter:'numeric_filter'},
                5: {sorter:'numeric_filter'},
                6: {sorter:'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".general.numerique.appli")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0, 0]],
            headers : {
                2: {sorter:'custom_criterion'},
                3: {sorter:'numeric_filter'},
                4: {sorter:'numeric_filter'},
                5: {sorter:'numeric_filter'},
                6: {sorter:'numeric_filter'},
                7: {sorter:'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".personnalise.numerique")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            headers: {
                0: {sorter: 'custom_criterion'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".one")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            headers: {
                2: {sorter: 'custom_criterion'},
                5: {sorter: 'numeric_filter'}
            },
            sortList: [[0,0], [5,1]],
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".one-access")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            headers: {
                0: {sorter: 'custom_numeric_filter'},
                2: {sorter: 'custom_criterion'},
                5: {sorter: 'numeric_filter'}
            },
            sortList: [[0,0]],
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".one-global")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[2, 1]],
            headers: {
                1: {sorter: 'custom_criterion'},
                2: {sorter: 'numeric_filter'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".one-influence")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[2, 1]],
            headers: {
                1: {sorter: 'custom_criterion'},
                2: {sorter: 'numeric_filter'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".one-influence-titre")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0, 0]],
            headers: {
                0: {sorter: 'numeric_filter'},
                2: {sorter: 'custom_criterion'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'},
                7: {sorter: 'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.hasClass("contenu-distribue")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0, 0]],
            headers: {
                0: {sorter: 'custom_numeric_filter'},
                2: {sorter: 'custom_criterion'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.hasClass("webradio")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0,0], [2,1]],
            headers: {
                0: {sorter: 'custom_numeric_filter'},
                1: {sorter: 'custom_criterion'},
                2: {sorter: 'numeric_filter'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'period_numeric_filter'},
                5: {sorter: 'numeric_filter'},
            },

            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".podcast.marque")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0,0], [2,1]],
            headers: {
                0: {sorter: 'custom_numeric_filter'},
                1: {sorter: 'custom_criterion'},
                2: {sorter: 'numeric_filter'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'custom_criterion'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'},
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".podcast.groupe")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0,0], [2,1]],
            headers: {
                0: {sorter: 'custom_numeric_filter'},
                1: {sorter: 'custom_criterion'},
                2: {sorter: 'numeric_filter'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'},
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".podcast.annexe")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0,0], [2,1]],
            headers: {
                0: {sorter: 'custom_numeric_filter'},
                1: {sorter: 'custom_criterion'},
                2: {sorter: 'numeric_filter'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'custom_criterion'},
                5: {sorter: 'custom_criterion'},
                6: {sorter: 'custom_criterion'},
                7: {sorter: 'numeric_filter'},
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.hasClass("synthetique")) {
        table_classement.tablesorter({
            sortList: [[3,1]],
            sortInitialOrder : 'desc',
            headers: {
                0: {sorter: 'numeric_filter'},
                2: {sorter: 'custom_criterion'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'},
                7: {sorter: 'numeric_filter'},
                8: {sorter: 'numeric_filter'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.hasClass("specifique-DDM") || table_classement.hasClass("specifique-DDT")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[1,0]],
            headers: {
                1: {sorter: 'custom_criterion_specific_classement'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter_evol'},
                6: {sorter: 'numeric_filter'},
                7: {sorter: 'numeric_filter_evol'},
                8: {sorter: 'numeric_filter'},
                9: {sorter: 'numeric_filter_evol'}
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.hasClass("specifique-PVPGID")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[1,0],[0,0]],
            headers : {
                1: { sorter:'custom_criterion_specific_classement' },
                3: { sorter:'numeric_filter' },
                4: { sorter:'numeric_filter' },
                5: { sorter:'numeric_filter_evol' },
                6: { sorter:'numeric_filter' },
                7: { sorter:'numeric_filter_evol' },
                8: { sorter:'numeric_filter' },
                9: { sorter:'numeric_filter_evol' }
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else if (table_classement.is(".unifie, .numerique")) {
        table_classement.tablesorter({
            sortInitialOrder : 'desc',
            sortList: [[0,0], [3,1]],
            headers: {
                2: {sorter: 'custom_criterion'},
                3: {sorter: 'numeric_filter'},
                4: {sorter: 'numeric_filter'},
                5: {sorter: 'numeric_filter'},
                6: {sorter: 'numeric_filter'},
                7: {sorter: 'numeric_filter'},
                8: {sorter: 'numeric_filter_evol'},
            },
            widgets: ["zebra"],
            widgetZebra: {
                css: ["even", "odd"]
            }
        });
    } else {
        table_classement.tablesorter({sortInitialOrder : 'desc'});
    }

});